import { useEffect, useState } from "react";
import { DataGrid } from "../../../components";
import { useCacheContext } from "../../../contexts/cache.context";
import { filtrosUrl, PermisoesHelper } from "../../../helpers";
import { ListLayout } from "../../../layouts";
import {
  EmailPersonalizadoService,
  history,
  notification
} from "../../../services";
import { cacheApi, responseErros } from "../../../utils";
import { contextos } from "../resources";

const emailPersonalizadoService = new EmailPersonalizadoService();

const ListEmailPersonalizadoView = () => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("email-personalizado-visualizar");
  const { cacheDto, setCacheDto } = useCacheContext();
  const [loading, setLoading] = useState(false);
  const [emailsPersonalizados, setEmailsPersonalizados] = useState([]);
  const [rowCount, setRowCount] = useState(null);

  const colunas = [
    {
      field: "contexto",
      headerName: "Contexto",
      flex: 500,
      filtrar: true,
      valueGetter: (params) => { 
        const exactMatch = contextos.find(
          (contexto) => contexto.value === params.value,
        );
        return exactMatch ? exactMatch.label : "";
      },
    },
  ];

  useEffect(() => {
    const filtros = filtrosUrl.get();
    buscarEmailsPersonalizados(filtros);
  }, []);

  const buscarEmailsPersonalizados = async function (filter) {
    const label = filtrosUrl.getUrl(filter);
    setLoading(true);
    const cacheBody = {
      dto: { cacheDto, setCacheDto },
      apiFunction: emailPersonalizadoService.getAll(filter),
    };
    const result = await cacheApi(label, cacheBody);
    if (!result.isAxiosError) {
      setEmailsPersonalizados(result.data.rows);
      setRowCount(result.data.count);
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const onClickCadastrarEmailPersonalizado = function () {
    history.push("/integracao/email-personalizado/create");
  };

  const onClickEditEmailPersonalizado = function (id) {
    history.push(`/integracao/email-personalizado/${id}`);
  };

  const onClickDeleteEmailPersonalizado = async function (id) {
    const data = emailsPersonalizados.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir o padrão de email com código ${data.codigo}?`,
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await emailPersonalizadoService.deletar(id);
      if (!result.isAxiosError) {
        buscarEmailsPersonalizados();
        notification.deletadoSucesso();
        setLoading(false);
      } else {
        responseErros(result);
        setLoading(false);
      }
    }
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarEmailsPersonalizados(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  const buscarPesquisaAvancada = async (filter) => {
    const label = filtrosUrl.getUrl(filter);
    setLoading(true);
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    const cacheBody = {
      dto: { cacheDto, setCacheDto },
      apiFunction: emailPersonalizadoService.getAllFiltroAvancado({
        ...filtrosAvancadosTemp,
        restritiva: true,
        porIntervalo,
      }),
    };
    const result = await cacheApi(label, cacheBody);
    if (!result.isAxiosError) {
      setEmailsPersonalizados(result.data.rows);
      setRowCount(result.data.count);
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  return (
    <ListLayout
      title="Email Personalizado"
      loading={loading}
      onClickCadastrar={onClickCadastrarEmailPersonalizado}
      permissaoButton={permissoesHelper.temPermisao(
        "email-personalizado-cadastrar",
      )}
    >
      <DataGrid
        rows={emailsPersonalizados}
        columns={colunas}
        onClickEdit={onClickEditEmailPersonalizado}
        onClickDelete={onClickDeleteEmailPersonalizado}
        visualizarShow={permissoesHelper.temPermisao(
          "email-personalizado-visualizar",
        )}
        editShow={permissoesHelper.temPermisao("email-personalizado-editar")}
        deleteShow={permissoesHelper.temPermisao("email-personalizado-excluir")}
        paginationMode={"server"}
        rowCount={rowCount}
        sendServer={(props) => sendServerDatagrid(props)}
        hideFiltroAvancado
      />
    </ListLayout>
  );
};

export default ListEmailPersonalizadoView;
